// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Articles_contentWrapper__cOtUp","blogDataWrapper":"Articles_blogDataWrapper__ULXB5"};